// extracted by mini-css-extract-plugin
export default {"routineblock":"tR","container":"uR","carousel":"vR","routine":"wR","heading":"xR","routinelist":"yR","routineitem":"zR","routineimg":"AR","routinedesc":"BR","routinename":"CR","routinetext":"ER","carouselwrap":"FR"};
    if(module.hot) {
      // 1714654894596
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  